import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
  BLUEMONEDDBUTTONS,
  GRAY_LIGHTER,
  VARIANT,
  WHITE,
} from "../constants/colors";

export default function DateDropdownFuture({ filtros, setFiltros }: any) {
  const [open, setOpen] = useState(false);

  const [filtroInterno, setFiltroInterno] = useState({
    initialDateFilter: filtros.initialDateFilter,
    finalDateFilter: filtros.finalDateFilter,
  });

  function mudarData() {
    setFiltros({
      ...filtros,
      initialDateFilter: filtroInterno.initialDateFilter,
      finalDateFilter: filtroInterno.finalDateFilter,
    });
  }

  return (
    <Menu closeOnSelect={false} isOpen={open}>
      <MenuButton
        minWidth="280px"
        bgColor={BLUEMONEDDBUTTONS}
        color="white"
        // fontWeight={"bold"}
        fontSize={"1.8vh"}
        minHeight={"40px"}
        px={"10px"}
        borderRadius={"6px"}
        onClick={() => {
          setOpen(!open);
        }}
      >
        {filtros.initialDateFilter && filtros.finalDateFilter
          ? `Filtrar por Data: ${moment(filtros.initialDateFilter).format(
              "DD/MM/YYYY"
            )}-${moment(filtros.finalDateFilter).format("DD/MM/YYYY")}`
          : `Filtrar por Data`}
      </MenuButton>
      <MenuList minWidth="180px">
        <MenuGroup title={"Data"}>
          {/* {/* <MenuItem
            onClick={(e: any) => {
              setFiltroInterno({
                ...filtroInterno,
                initialDateFilter: moment(e.targetvalue)
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                finalDateFilter: moment(e.targetvalue)
                  .endOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              });
            }}
          >
            <Text color={VARIANT}>HOJE</Text>
          </MenuItem> */}
          <MenuItem
            onClick={(e: any) => {
              setFiltroInterno({
                ...filtroInterno,
                initialDateFilter: moment()
                  .add(1, "day")
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                finalDateFilter: moment()
                  .add(1, "day")
                  .endOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              });
            }}
          >
            <Text color={VARIANT}>AMANHÃ</Text>
          </MenuItem>
          <MenuItem
            onClick={(e: any) => {
              setFiltroInterno({
                ...filtroInterno,
                initialDateFilter: moment(e.targetvalue)
                  .add(1, "day")
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                finalDateFilter: moment(e.targetvalue)
                  .add(8, "day")
                  .endOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              });
            }}
          >
            <Text color={VARIANT}>PRÓXIMOS 7 DIAS</Text>
          </MenuItem>
          <MenuItem
            color={VARIANT}
            onClick={(e: any) => {
              setFiltroInterno({
                ...filtroInterno,
                initialDateFilter: moment(e.targetvalue)
                  .add(1, "day")
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                finalDateFilter: moment(e.targetvalue)
                  .add(16, "day")
                  .endOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              });
            }}
          >
            <Text>PRÓXIMOS 15 DIAS</Text>
          </MenuItem>
          <MenuItem
            color={VARIANT}
            onClick={(e: any) => {
              setFiltroInterno({
                ...filtroInterno,
                initialDateFilter: moment(e.targetvalue)
                  .add(1, "day")
                  .startOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                finalDateFilter: moment(e.targetvalue)
                  .add(31, "day")
                  .endOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              });
            }}
          >
            <Text>PRÓXIMOS 30 DIAS</Text>
          </MenuItem>
        </MenuGroup>
        <MenuGroup title={"De"}>
          <MenuItem>
            <Input
              type="date"
              value={moment(filtroInterno.initialDateFilter).format(
                "YYYY-MM-DD"
              )}
              onChange={(e: any) => {
                setFiltroInterno({
                  ...filtroInterno,
                  initialDateFilter: moment(e.target.value).startOf("day").format(
                    "YYYY-MM-DDTHH:mm:ss.SSS"
                  ),
                });
              }}
            />
          </MenuItem>
        </MenuGroup>
        <MenuGroup title={"Até "}>
          <MenuItem>
            <Input
              type="date"
              value={moment(filtroInterno.finalDateFilter).format("YYYY-MM-DD")}
              onChange={(e: any) => {
                setFiltroInterno({
                  ...filtroInterno,
                  finalDateFilter: moment(e.target.value).endOf("day").format(
                    "YYYY-MM-DDTHH:mm:ss.SSS"
                  ),
                });
              }}
            />
          </MenuItem>
        </MenuGroup>
        <MenuGroup>
          <Flex w={"100%"} justifyContent="center">
            <Button
              bgColor={VARIANT}
              color="white"
              mt={2}
              w={"90%"}
              onClick={() => {
                setOpen(false);
                mudarData();
              }}
            >
              Filtrar
            </Button>
          </Flex>
        </MenuGroup>
      </MenuList>
    </Menu>
  );
}
